module.exports = __webpack_public_path__ + "img/palas_pickleball.5b95db66.jpg";